import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import FavoriteIcon from '@mui/icons-material/Favorite';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import RestoreIcon from '@mui/icons-material/Restore';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import React from 'react';
export default function BottomNavigationExample() {
    const [value, setValue] = React.useState(0);
    return (_jsxs(BottomNavigation, Object.assign({ value: value, onChange: (event, newValue) => {
            setValue(newValue);
        }, showLabels: true, sx: { width: 500 } }, { children: [_jsx(BottomNavigationAction, { label: "Recents", icon: _jsx(RestoreIcon, {}) }), _jsx(BottomNavigationAction, { label: "Favorites", icon: _jsx(FavoriteIcon, {}) }), _jsx(BottomNavigationAction, { label: "Nearby", icon: _jsx(LocationOnIcon, {}) })] })));
}
